import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { KIND, SIZE } from 'baseui/button'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { StyledContainer, HeaderContainer, StyledTitle } from '../Tools/styled-components'
import IconCarbonCatalog from '@/shared/icons/IconCarbonCatalog'
import IconCarbonLifebuoy from '@/shared/icons/IconCarbonLifebuoy'

const Resources = ({ country }) => {
  const { t } = useTranslation()
  if (country !== 'fr') {
    return null
  }

  return (
    <StyledContainer>
      <HeaderContainer>
        <StyledTitle>{t('subscriptionForm:resources.section_title')}</StyledTitle>
      </HeaderContainer>
      <SDButton
        kind={KIND.secondary}
        size={SIZE.compact}
        onClick={() => window.open(t('subscriptionForm:resources.link'), '_blank')}
        startEnhancer={() => <IconCarbonCatalog size={24} />}
      >
        {t('subscriptionForm:resources.title')}
      </SDButton>
      <SDButton
        kind={KIND.secondary}
        size={SIZE.compact}
        onClick={() => window.open(t('subscriptionForm:resources.sos_link'), '_blank')}
        startEnhancer={() => <IconCarbonLifebuoy size={24} />}
      >
        {t('subscriptionForm:resources.sos_title')}
      </SDButton>
    </StyledContainer>
  )
}

Resources.propTypes = {
  country: PropTypes.string,
}

export default Resources
